/* import __COLOCATED_TEMPLATE__ from './posting-create-details.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

import {
  action,
  get,
  getProperties,
  set,
  setProperties,
} from '@ember/object';

import {
  POSTING_CREATE_USE_KEY_DATES,
  KEY_DATES_OPTIONS,
  POSTING_CREATE_ESTIMATED_DAY_TYPES,
} from 'sh-www/constants/routes/posting-create';

const CLASS_NAME = 'SH-c-posting-create-details';

class PostingCreateDetailsComponent extends Component {
  @service('states/routes/posting-create')
  state;

  @service('state-managers/routes/posting-create')
  stateManager;

  get CLASS_NAME() {
    return CLASS_NAME;
  }

  get _areFormElementsDisabled() {
    return get(this.state, 'areFormElementsDisabled');
  }

  get _updatedHasKeyDates() {
    return get(this.state, 'updatedHasKeyDates');
  }

  get _updatedScheduleItems() {
    return get(this.state, 'updatedScheduleItems');
  }

  get _scheduleErrors() {
    const errors = get(this.state, 'errors');

    return Object.entries(errors).reduce((accum, [errorKey, errorValues]) => {
      if (errorKey.startsWith('schedule') && errorValues) {
        const index = errorKey.split('.')[1];

        // 'schedule' handled below input
        if (index === undefined) {
          return accum;
        }

        // yup or server error
        const errorString = Array.isArray(errorValues)
          ? errorValues.join('. ')
          : errorValues;

        const errorAtIndex = accum[index];

        const combinedErrorString = errorAtIndex
          ? `${errorAtIndex}. ${errorString}`
          : errorString;

        // ensure correct punctuation
        accum[index] = combinedErrorString.replace(/\.{2,}/g, '.');
      }

      return accum;
    }, { });
  }

  get _showExamples() {
    const {
      updatedExamplesExplictlyShown,
      updatedExamples,
    } = getProperties(this.state, [
      'updatedExamplesExplictlyShown',
      'updatedExamples',
    ]);

    return updatedExamplesExplictlyShown
      || updatedExamples;
  }

  get _keyDatesDropdownOptions() {
    return KEY_DATES_OPTIONS;
  }

  get _isHasKeyDatesNo() {
    return POSTING_CREATE_USE_KEY_DATES.NO;
  }

  get _isHasKeyDatesYes() {
    return POSTING_CREATE_USE_KEY_DATES.YES;
  }

  get _isHasKeyDatesNoSelected() {
    return this._updatedHasKeyDates === POSTING_CREATE_USE_KEY_DATES.NO;
  }

  get _isHasKeyDatesYesSelected() {
    return this._updatedHasKeyDates === POSTING_CREATE_USE_KEY_DATES.YES;
  }

  get _updatedDeliverables() {
    return get(this.state, 'updatedDeliverables');
  }

  get _updatedDescription() {
    return get(this.state, 'updatedDescription');
  }

  set _updatedDescription(value) {
    set(this.state, 'updatedDescription', value);

    set(this.state, 'errors', {
      ...this.state.errors,
      description: undefined,
    });
  }

  get _updatedExamples() {
    return get(this.state, 'updatedExamples');
  }

  set _updatedExamples(value) {
    set(this.state, 'updatedExamples', value);

    set(this.state, 'errors', {
      ...this.state.errors,
      examples: undefined,
    });
  }

  @action
  handleMessageInput(text) {
    set(this.state, 'errors', {
      ...this.errors,
      description: undefined,
      message: undefined,
    });

    this.stateManager.setDirectFreelancerMessage(text);
  }

  @action
  handleDeliverablesUpdate(deliverables) {
    set(this.state, 'errors', {
      ...this.state.errors,
      assignment_deliverables: undefined,
    });

    this.stateManager.updateAssignmentDeliverables(deliverables);
  }

  @action
  handleExamplesExplictlyShow() {
    this.stateManager.updateExamplesExplictlyShown(true);
  }

  @action
  handleScheduleUpdate(schedule) {
    // clear related errors
    const errorsToClear = Object.entries(this.state.errors).reduce((accum, [errorKey, errorValues]) => {
      if (errorKey.startsWith('schedule') && errorValues) {
        accum[errorKey] = undefined;
      }

      return accum;
    }, { });

    set(this.state, 'errors', {
      ...this.state.errors,
      ...errorsToClear,
    });

    this.stateManager.updateAssignmentScheduleItems(schedule);
  }

  @action
  handleUseKeyDates(useKeyDates) {
    set(this.state, 'errors', {
      ...this.state.errors,
      schedule: undefined,
    });

    this.stateManager.updateHasKeyDates(useKeyDates);
  }

  @action
  updateEstimatedDays(value) {
    set(this.state, 'errors', {
      ...this.state.errors,
      estimated_days: undefined,
    });

    const estimatedCustomDays = value.replace(/[^0-9]/g, '');
    const customDaysInt = Number.parseInt(estimatedCustomDays);

    const updatedEstimatedCustomDays =
      Number.isFinite(customDaysInt) && customDaysInt > 0
        ? `${customDaysInt}`
        : '';

    setProperties(this.state, {
      updatedEstimatedCustomDays: `${updatedEstimatedCustomDays}`,
      updatedEstimatedDaysTypeEnum: POSTING_CREATE_ESTIMATED_DAY_TYPES.CUSTOM_NUMBER_OF_DAYS,
    });
  }
}

export default PostingCreateDetailsComponent;
